module.exports = __webpack_public_path__ + "static/media/paragard-logo-pwa@2x.aaebed17.jpg";